const COMPLETED_STAGE_PREFIX = 'student_growth_completed_roadmap_stages'
const COMPLETED_STEP_PREFIX = 'student_learning_completed_steps'
const TIMELINE_PREFIX = 'student_learning_timeline'
const XP_PREFIX = 'student_learning_xp'

function makeStep(id, title, minutes = 30, exercise = '完成 1 个小练习', project = '整理成一个可展示作品') {
  return {
    id,
    title,
    minutes,
    video: `视频：${title} 入门讲解`,
    doc: `文档：${title} 学习笔记模板`,
    exercise,
    project,
    quiz: `小测试：用自己的话解释 ${title}`,
    xp: 20,
  }
}

const ROADMAP_TEMPLATES = {
  java: {
    label: 'Java 后端开发',
    match: /java|spring|后端|backend|软件|计算机|网络工程|开发/i,
    stages: [
      {
        id: 'java-basics',
        name: 'Java 基础',
        goal: '先把 Java 核心语法跑通，能写出小练习。',
        steps: [
          makeStep('variables', 'Java 变量', 30, '声明 3 个变量并打印学生信息', '学生信息小练习'),
          makeStep('conditions', '条件判断', 30, '写一个成绩等级判断', '成绩判断工具'),
          makeStep('loops', '循环', 30, '用循环打印 1-100 的偶数', '练习题批量统计'),
          makeStep('arrays', '数组', 35, '统计数组最大值和平均值', '学生成绩统计'),
          makeStep('oop', '面向对象', 45, '定义 Student 类并创建对象', '学生信息管理小程序'),
        ],
        projects: ['学生信息管理小程序', '命令行记账本'],
        competitions: ['蓝桥杯 Java 入门题', '校内程序设计练习赛'],
        certificates: ['计算机二级 Java 可选', '软考初级可了解'],
      },
      {
        id: 'mysql',
        name: 'MySQL',
        goal: '能设计简单数据表，并用 SQL 完成增删改查。',
        steps: [
          makeStep('tables', '表和字段', 30, '设计用户表和商品表', '校园二手交易数据库'),
          makeStep('crud', '增删改查 SQL', 35, '写 4 条基础 SQL', '图书借阅管理表设计'),
          makeStep('relations', '表关系', 35, '画出用户、订单、商品关系', '订单关系建模'),
          makeStep('indexes', '索引基础', 30, '解释主键和索引的区别', '查询优化记录'),
        ],
        projects: ['校园二手交易数据库设计', '图书借阅管理表设计'],
        competitions: ['数据库课程设计', '校内创新实践项目'],
        certificates: ['软考数据库相关内容'],
      },
      {
        id: 'spring-boot',
        name: 'Spring Boot',
        goal: '能写出基础后端接口，让页面或工具请求数据。',
        steps: [
          makeStep('controller', 'Controller 接口', 35, '写一个商品列表接口', 'Spring Boot 管理系统'),
          makeStep('service', 'Service 业务层', 35, '把查询逻辑放进 Service', '博客后台接口'),
          makeStep('mapper', 'Mapper / ORM', 40, '读取数据库中的商品数据', '商品管理接口'),
          makeStep('api-test', '接口测试', 30, '用接口测试工具验证返回数据', '接口测试清单'),
        ],
        projects: ['Spring Boot 管理系统', '博客后台接口'],
        competitions: ['中国国际大学生创新大赛项目原型', '互联网+ 创新创业类'],
        certificates: ['软考中级软件设计师', '华为 HCIA 可选'],
      },
      {
        id: 'project-practice',
        name: '项目实战',
        goal: '做出一个可演示、可截图、能写进简历的小项目。',
        steps: [
          makeStep('scope', '最小版本范围', 25, '只保留 3 个必须功能', '项目 MVP 清单'),
          makeStep('core-flow', '核心流程实现', 45, '跑通 1 条完整业务流程', '校园活动报名系统'),
          makeStep('screenshots', '截图和说明', 30, '准备 5 张项目截图', '项目展示材料'),
          makeStep('review', '问题复盘', 30, '记录 3 个问题和解决办法', '项目复盘文档'),
        ],
        projects: ['校园二手交易系统', '社团活动报名系统', '个人博客系统'],
        competitions: ['挑战杯项目计划', '中国国际大学生创新大赛'],
        certificates: ['项目作品优先，证书后置'],
      },
    ],
  },
  data: {
    label: '数据分析',
    match: /数据|大数据|分析|统计|sql|python|可视化/i,
    stages: [
      {
        id: 'data-basics',
        name: '数据分析基础',
        goal: '理解表格、指标和业务问题，先能做出清晰结论。',
        steps: [
          makeStep('excel', 'Excel 数据整理', 30, '清洗一份表格并做透视表', '销售数据分析表'),
          makeStep('sql', 'SQL 查询', 35, '写 5 条查询语句', '用户行为查询练习'),
          makeStep('metrics', '指标理解', 30, '解释转化率、留存率、客单价', '指标字典'),
        ],
        projects: ['销售数据分析报告', '校园消费数据看板'],
        competitions: ['统计建模大赛', '市场调研类比赛'],
        certificates: ['计算机二级', '数据分析工具证书可选'],
      },
      {
        id: 'python-data',
        name: 'Python 数据处理',
        goal: '用 Python 完成读取、清洗、统计和可视化。',
        steps: [
          makeStep('pandas', 'Pandas 基础', 40, '读取 CSV 并筛选数据', '数据清洗脚本'),
          makeStep('visualization', '可视化图表', 35, '画出 3 张关键图表', '分析图表页'),
          makeStep('report', '分析报告', 40, '写出问题、方法、结论和建议', '业务分析报告'),
        ],
        projects: ['招聘岗位数据分析', '电商评论分析'],
        competitions: ['服务外包创新创业大赛', '统计建模大赛'],
        certificates: ['Python 基础证书可选'],
      },
    ],
  },
  ai: {
    label: 'AI 应用开发',
    match: /ai|人工智能|模型|智能|agent|大模型/i,
    stages: [
      {
        id: 'ai-basics',
        name: 'AI 工具基础',
        goal: '先理解 AI 工具能做什么，适合解决什么问题。',
        steps: [
          makeStep('prompt', 'Prompt 基础', 30, '写 3 个可复用提示词', '学习助手提示词库'),
          makeStep('workflow', 'AI 工作流', 35, '把一个任务拆成输入、处理、输出', '简历优化工作流'),
          makeStep('limits', '模型边界', 30, '记录 3 个不可靠输出并修正', 'AI 使用规范'),
        ],
        projects: ['AI 学习助手', 'AI 简历检查器'],
        competitions: ['AI 应用赛', '计算机设计大赛'],
        certificates: ['英语四六级', 'AI 工具课程证书可选'],
      },
      {
        id: 'ai-project',
        name: 'AI 应用项目',
        goal: '做一个能演示的 AI 小工具，并说明场景和边界。',
        steps: [
          makeStep('scenario', '场景定义', 30, '明确用户、痛点和输入输出', 'AI 工具需求文档'),
          makeStep('prototype', '原型实现', 45, '做出一个可点击原型', 'AI 小工具 Demo'),
          makeStep('evaluation', '效果评估', 35, '记录成功样例和失败样例', '效果评估表'),
        ],
        projects: ['AI 面试助手', 'AI 课程总结工具'],
        competitions: ['中国大学生计算机设计大赛', '创新创业大赛'],
        certificates: ['项目作品优先'],
      },
    ],
  },
  general: {
    label: '通用成长路线',
    match: /.*/i,
    stages: [
      {
        id: 'direction',
        name: '确定方向',
        goal: '先从专业、兴趣和岗位里选出一个短期目标。',
        steps: [
          makeStep('self-check', '自我盘点', 25, '写下专业、优势和不想做的事', '个人方向清单'),
          makeStep('job-search', '岗位观察', 30, '找 3 个真实岗位描述', '岗位关键词表'),
          makeStep('first-goal', '第一个目标', 30, '确定一个 30 天内可推进目标', '30 天计划'),
        ],
        projects: ['个人成长计划', '岗位分析报告'],
        competitions: ['挑战杯调研类', '创新创业训练计划'],
        certificates: ['英语四六级', '办公技能证书可选'],
      },
      {
        id: 'portfolio',
        name: '作品与简历',
        goal: '做一个能证明能力的小成果，再整理成简历素材。',
        steps: [
          makeStep('small-work', '最小作品', 35, '做一个小报告、小工具或小作品', '个人作品页'),
          makeStep('resume-bullet', '简历表达', 30, '写 3 条结果导向 bullet', '简历素材清单'),
          makeStep('interview-story', '面试表达', 30, '准备 2 分钟项目介绍', '项目介绍稿'),
        ],
        projects: ['个人作品集', '调研报告', '数据看板'],
        competitions: ['校内实践项目', '创新创业训练计划'],
        certificates: ['按目标岗位选择'],
      },
    ],
  },
}

function inferTemplate(target = '') {
  const value = String(target || '').toLowerCase()
  return Object.values(ROADMAP_TEMPLATES).find((template) => template.match.test(value)) || ROADMAP_TEMPLATES.general
}

function estimateStageTime(index) {
  if (index === 0) return '1-2周'
  if (index === 1) return '2-3周'
  return '3-5周'
}

function scopedKey(prefix, plan) {
  const id = plan?.id || plan?.targetDirection || plan?.target_direction || 'local'
  return `${prefix}:${id}`
}

function readArray(key) {
  if (typeof window === 'undefined') return []
  try {
    const parsed = JSON.parse(window.localStorage.getItem(key) || '[]')
    return Array.isArray(parsed) ? parsed.map(String) : []
  } catch {
    return []
  }
}

function writeArray(key, value) {
  if (typeof window !== 'undefined') window.localStorage.setItem(key, JSON.stringify(value))
}

function stepKey(stageId, stepId) {
  return `${stageId}:${stepId}`
}

export function getRoadmapTemplateOptions() {
  return Object.entries(ROADMAP_TEMPLATES).map(([key, template]) => ({
    key,
    label: template.label,
    stageCount: template.stages.length,
  }))
}

export function getCompletedRoadmapStages(plan) {
  return readArray(scopedKey(COMPLETED_STAGE_PREFIX, plan))
}

export function markRoadmapStageComplete(stageId, plan) {
  const current = getCompletedRoadmapStages(plan)
  const next = Array.from(new Set([...current, String(stageId)]))
  writeArray(scopedKey(COMPLETED_STAGE_PREFIX, plan), next)
  return next
}

export function getCompletedLearningSteps(plan) {
  return readArray(scopedKey(COMPLETED_STEP_PREFIX, plan))
}

export function getLearningXp(plan) {
  if (typeof window === 'undefined') return 0
  return Number(window.localStorage.getItem(scopedKey(XP_PREFIX, plan)) || 0)
}

export function getLearningTimeline(plan) {
  if (typeof window === 'undefined') return []
  try {
    const parsed = JSON.parse(window.localStorage.getItem(scopedKey(TIMELINE_PREFIX, plan)) || '[]')
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}

export function completeLearningStep(plan, stage, step) {
  if (!stage || !step || typeof window === 'undefined') {
    return { completedSteps: [], xp: 0, timeline: [] }
  }
  const completedKey = scopedKey(COMPLETED_STEP_PREFIX, plan)
  const current = readArray(completedKey)
  const id = stepKey(stage.id, step.id)
  const completedSteps = Array.from(new Set([...current, id]))
  writeArray(completedKey, completedSteps)

  const xpKey = scopedKey(XP_PREFIX, plan)
  const alreadyCompleted = current.includes(id)
  const xp = getLearningXp(plan) + (alreadyCompleted ? 0 : Number(step.xp || 20))
  window.localStorage.setItem(xpKey, String(xp))

  const timelineKey = scopedKey(TIMELINE_PREFIX, plan)
  const timeline = getLearningTimeline(plan)
  const nextTimeline = alreadyCompleted
    ? timeline
    : [
      {
        id: `${Date.now()}-${stage.id}-${step.id}`,
        title: `完成 ${stage.name} / ${step.title}`,
        xp: Number(step.xp || 20),
        createdAt: new Date().toISOString(),
      },
      ...timeline,
    ].slice(0, 20)
  window.localStorage.setItem(timelineKey, JSON.stringify(nextTimeline))

  const allStageStepsDone = (stage.steps || []).every((item) => completedSteps.includes(stepKey(stage.id, item.id)))
  if (allStageStepsDone) markRoadmapStageComplete(stage.id, plan)

  return { completedSteps, xp, timeline: nextTimeline, stageCompleted: allStageStepsDone }
}

export function buildStudentRoadmap(plan) {
  if (!plan) return []
  const generatedStages = Array.isArray(plan.stages) ? plan.stages : []
  const isDetailedAiPlan = (plan.source === 'ai_generated' || Number(plan.schemaVersion) >= 2)
    && generatedStages.some((stage) => Array.isArray(stage.nodes) && stage.nodes.length)
  if (isDetailedAiPlan) {
    const completedStageIds = getCompletedRoadmapStages(plan)
    const completedStepIds = getCompletedLearningSteps(plan)
    const firstIncompleteStage = generatedStages.findIndex((stage) => !completedStageIds.includes(String(stage.id)))
    return generatedStages.map((stage, index) => {
      const stageId = String(stage.id || `stage-${index + 1}`)
      const steps = (stage.nodes || []).map((node, nodeIndex) => {
        const id = String(node.id || `${stageId}-node-${nodeIndex + 1}`)
        return {
          ...node,
          id,
          title: node.title || `学习节点 ${nodeIndex + 1}`,
          minutes: Number(node.estimatedMinutes || plan.dailyMinutes || 30),
          exercise: node.steps?.[0] || node.professionalGoal || '',
          project: ['practice', 'project'].includes(node.type) ? node.deliverables?.[0] || '' : '',
          quiz: node.acceptanceCriteria?.[0] || '',
          doc: node.resources?.[0] || '',
          xp: node.type === 'project' ? 50 : node.type === 'practice' ? 30 : 20,
          completed: completedStepIds.includes(stepKey(stageId, id)),
          stageId,
        }
      })
      const completedSteps = steps.filter((step) => step.completed).length
      const completed = completedStageIds.includes(stageId) || (steps.length > 0 && completedSteps === steps.length)
      return {
        ...stage,
        id: stageId,
        goal: stage.stageGoal || stage.description || '',
        steps,
        learn: stage.coreKnowledge || steps.map((step) => step.title),
        todayTask: steps.find((step) => !step.completed)?.title || steps[0]?.title || stage.name,
        order: index + 1,
        estimatedTime: stage.durationDays ? `${stage.durationDays} 天` : estimateStageTime(index),
        projects: plan.projects || [],
        competitions: plan.competitions || [],
        certificates: plan.certificates || [],
        completed,
        locked: firstIncompleteStage >= 0 && index > firstIncompleteStage,
        stepProgress: steps.length ? Math.round((completedSteps / steps.length) * 100) : 0,
        completedSteps,
        target: plan.targetCareer || plan.target,
        templateLabel: 'AI 专属路线',
      }
    })
  }
  const target = plan.targetDirection || plan.target_direction || plan.direction || plan.targetCareer || plan.target || '成长目标'
  const template = inferTemplate(target)
  const completedStageIds = getCompletedRoadmapStages(plan)
  const completedStepIds = getCompletedLearningSteps(plan)
  const unlockedCount = template.stages.filter((stage) => completedStageIds.includes(stage.id)).length

  return template.stages.map((stage, index) => {
    const steps = (stage.steps || []).map((step) => ({
      ...step,
      completed: completedStepIds.includes(stepKey(stage.id, step.id)),
      stageId: stage.id,
    }))
    const completedSteps = steps.filter((step) => step.completed).length
    return {
      ...stage,
      steps,
      learn: steps.map((step) => step.title),
      todayTask: steps.find((step) => !step.completed)?.title || stage.steps?.[0]?.title || stage.name,
      order: index + 1,
      estimatedTime: stage.estimatedTime || estimateStageTime(index),
      completed: completedStageIds.includes(stage.id) || (steps.length > 0 && completedSteps === steps.length),
      locked: index > unlockedCount,
      stepProgress: steps.length ? Math.round((completedSteps / steps.length) * 100) : 0,
      completedSteps,
      target,
      templateLabel: template.label,
    }
  })
}

export function findCurrentStage(roadmap, completedIds = []) {
  if (!roadmap.length) return null
  return roadmap.find((stage) => !completedIds.includes(stage.id) && !stage.completed) || roadmap[roadmap.length - 1]
}

export function getCurrentLearningStep(stage) {
  return stage?.steps?.find((step) => !step.completed) || stage?.steps?.[0] || null
}

export function getRoadmapSummary(roadmap, completedIds = []) {
  const completedSet = new Set(completedIds.map(String))
  const completedCount = roadmap.filter((stage) => completedSet.has(stage.id) || stage.completed).length
  const current = findCurrentStage(roadmap, completedIds)
  const currentStep = getCurrentLearningStep(current)
  const currentIndex = current ? roadmap.findIndex((stage) => stage.id === current.id) : -1
  const next = currentIndex >= 0 ? roadmap[currentIndex + 1] || null : null
  const recent = currentIndex >= 0 ? roadmap.slice(currentIndex, currentIndex + 3) : roadmap.slice(0, 3)
  const progress = roadmap.length ? Math.round((completedCount / roadmap.length) * 100) : 0
  return { completedCount, current, currentStep, next, progress, recent, total: roadmap.length }
}
